<template>
  <modal :bindClass="[ 'okDialog' ]" :isOpen="isOpenModal('okModal')">
    <p class="dialog__title">Gracias por tu compra</p>  
    <p class="dialog__text" v-if="!isPrestamo && pack && productType !== 'recharge' && productType !== 'sponsorship'">Tu compra del paquete {{ pack.nombre_comercial }} de Q{{ pack.precio_paquete }} por {{ formatVigencia }} fué realizada con éxito.</p>
    <p class="dialog__text" v-if="isPrestamo">Tu préstamo de {{ loan.NOMBRE_COMERCIAL }} por {{ formatVigencia }} por {{ loan.PRECIO_PAQUETE}} fue realizado con éxito. El precio del préstamo será descontado de tu próxima recarga.</p>
    <p class="dialog__text" v-if="productType === 'recharge'">Tu compra de recarga por {{ recharge }} fué realizada con éxito.</p>
    <p class="dialog__text" v-if="productType === 'sponsorship'">Has recibido tu paquete patrocinado de 100 MB con vigencia de 30 dias.</p>
    <p class="text" v-if="usingRenew">Tu paquete tiene una recurrencia de {{ renewFrecuency }} dias</p>
    <div class="button__group column">
      <a @click="finalizeTransaction" class="button button--red button--center">Finalizar</a>
      <a @click="returnPackages" class="button button--gray button--center button--max">¿Deseas hacer otra operación?</a>
    </div>
    <div class="button__group spaced">
      <button @click="returnPackages" class="button button--flex button--min button--flat button--fontRed ">Regresar</button>
      <button @click="goFaqs" class="button button--flex button--min button--flat button--fontBlue ">Ayuda</button>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Modal from '../Modal';

export default {
  name: 'okModal',
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      'closeModal',
      // 'toUsingRenew',
      // 'setRenewFrecuency'
      'resetClientValues',
      'resetPurchaseValues'
    ]),
    finalizeTransaction() {
      this.resetClientValues();
      this.resetPurchaseValues();
      this.closeModal('okModal');
      global.router.push('/');
    },
    goFaqs() {
      this.closeModal('okModal');
      global.router.push('faqs');
    },
    returnPackages() {
      this.resetPurchaseValues();
      this.closeModal('okModal');
      global.router.push('/packages');
    }
  },
  computed: {
    ...mapGetters([
      'isOpenModal',
      'usingRenew',
      'renewFrecuency',
      'packagesType',
      'productType',
      'pack',
      'loan',
      'recharge'
    ]),
    isPrestamo() {
      return this.productType === 'prestamo';
    },
    formatVigencia() {
      if (!this.isPrestamo) {
        if (this.pack.vigencia_paquete.indexOf('Días') > -1 || this.pack.vigencia_paquete.indexOf('Día') > -1) {
          return this.pack.vigencia_paquete;
        }
        return `${this.pack.vigencia_paquete} días`;
      }
      return `${this.loan.VIGENCIA.slice(0, -1)} días`;
    }
  },
  components: {
    Modal
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/modals/OkModal.vue